import s from './LoadingSpinner.module.css'

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large'
  color?: string
}

export default function LoadingSpinner({
  size = 'medium',
  color = 'var(--color-green)',
}: LoadingSpinnerProps) {
  return (
    <div className={`${s.spinner} ${s[size]}`} style={{ borderTopColor: color }}>
      <div className={s.inner}></div>
    </div>
  )
}
